import styled from 'styled-components';

const SkipLink = styled.a`
  position: absolute;
  inset-inline-start: 24px;
  top: 16px;
  padding: 10px 18px;
  background: ${({ theme }) => theme.colors.secondary};
  color: ${({ theme }) => theme.colors.textDark};
  border-radius: ${({ theme }) => theme.layout.radiusSm};
  transform: translateY(-150%);
  transition: transform 0.2s ease;

  &:focus {
    transform: translateY(0);
  }
`;

const SkipToContent = () => (
  <SkipLink href="#main-content">تجاوز إلى المحتوى</SkipLink>
);

export default SkipToContent;
